export enum CompanyFiscalType {
  NONE = 'restaurant',
  RETAIL = 'retail',
  BLACKBOX = 'blackbox restaurant',
  BLACKBOX2 = 'blackbox restaurant v2',
  DUTCH = 'NL fiscal cash register',
  SRM = 'quebec-srm',
  FRENCH = 'French Fiscal'
}

export enum BlackboxType {
  CHECKBOX_EMULATOR = 'Checkbox emulator',
  ZWARTEDOOS = 'Zwartedoos',
  CHECKBOX = 'Checkbox'
}
export interface FdmRequestHeader {
  name: string;
  value: string;
  secret: boolean;
}
